import React from 'react'
import "./Footer.css"

export default function Footer(){
    return(
      <div className='footer-container'>
      <p>Created by</p>
      <a href='https://www.google.co.ve/'>David Aponte</a>
      </div>   
    )
}